import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupGenerateCdicCoupon = () => {
  //page hook
  const { t } = useTranslation();
  return {
    programId: Yup.string().required(
      t("validation.required", {
        program: t("page.program"),
      })
    ),
    programName: Yup.string().required(
      t("validation.required", {
        programName: t("page.program_name"),
      })
    ),
    serviceCategory:Yup.string().required(
      t("validation.required", {
        serviceCategory: t("page.service_category"),
      })
    ),
    userId: Yup.string().required(
      t("validation.required", {
        userId: t("page.userId"),
      })
    ),
    date: Yup.array()
      .length(2)
      .required(
        t("validation.required", {
          date: t("page.date"),
        })
      ),
  };
};
